import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AnimatedPage from "../components/AnimatedPage";

function FundManager() {
    const navigate = useNavigate();
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [isRefreshing, setIsRefreshing] = useState(false);

    useEffect(() => {
        fetchBalance();
    }, []);

    const fetchBalance = () => {
        setIsRefreshing(true);
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("user")}` }
        })
        .then((res) => {
            setProfile(res.data.data);
            localStorage.setItem("profile", JSON.stringify(res.data.data));
            setTimeout(() => setIsRefreshing(false), 500); // Tạo hiệu ứng xoay một chút cho mượt
        })
        .catch(() => {
            setIsRefreshing(false);
            localStorage.removeItem("user");
        });
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#f4f6f8", overflow: "hidden" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                body { background-color: #f4f6f8; margin: 0; padding: 0; color: #333; }
                
                .fm-app-main {
                    position: fixed; top: 0; bottom: 0; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #f4f6f8; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                }
                .fm-app-main::-webkit-scrollbar { display: none; }

                /* HEADER */
                .fm-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; background: #fff;
                    position: sticky; top: 0; z-index: 50; 
                }
                .fm-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .fm-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; margin-right: -24px;}

                /* WALLET SECTION */
                .fm-wallet-sec {
                    background: #fff; padding: 20px 20px 25px; position: relative;
                    border-bottom: 1px solid #f0f0f0;
                }
                .fm-wallet-title {
                    display: flex; align-items: center; font-size: 14px; font-weight: 600; color: #333;
                }
                .fm-wallet-icon { margin-right: 6px; display: flex; align-items: center;}
                .fm-refresh-icon { 
                    margin-left: 8px; cursor: pointer; color: #2cb4e8; display: flex; align-items: center;
                }
                .fm-refresh-icon.spinning svg { animation: spin 1s linear infinite; }
                @keyframes spin { 100% { transform: rotate(360deg); } }

                .fm-balance {
                    font-size: 24px; font-weight: 700; color: #003366; margin: 10px 0 20px;
                }

                .fm-wallet-graphic {
                    position: absolute; right: 20px; top: 20px; width: 80px; height: auto;
                    opacity: 0.9;
                }

                .fm-action-btns {
                    display: flex; gap: 15px;
                }
                .fm-btn-fill {
                    background: #2cb4e8; color: #fff; border: none; border-radius: 20px;
                    padding: 8px 24px; font-size: 13px; font-weight: 600; cursor: pointer;
                    box-shadow: 0 4px 10px rgba(44, 180, 232, 0.2); transition: 0.2s;
                }
                .fm-btn-outline {
                    background: #fff; color: #2cb4e8; border: 1.5px solid #2cb4e8; border-radius: 20px;
                    padding: 7px 24px; font-size: 13px; font-weight: 600; cursor: pointer; transition: 0.2s;
                }
                .fm-btn-fill:active { transform: scale(0.96); }
                .fm-btn-outline:active { transform: scale(0.96); background: #f0f9ff;}

                /* HISTORY CARDS */
                .fm-history-grid {
                    display: flex; gap: 10px; padding: 15px;
                }
                .fm-history-card {
                    flex: 1; background: #fff; border-radius: 12px; padding: 12px;
                    display: flex; align-items: center; justify-content: space-between;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04); cursor: pointer; text-decoration: none;
                    transition: transform 0.2s;
                }
                .fm-history-card:active { transform: scale(0.98); }
                
                .fm-hc-left { display: flex; align-items: center; gap: 10px; flex: 1;}
                .fm-hc-icon {
                    width: 32px; height: 32px; border-radius: 50%; background: #333;
                    display: flex; align-items: center; justify-content: center; color: #f88c14;
                }
                .fm-hc-text { font-size: 12px; font-weight: 600; color: #333; }
                .fm-hc-arrow { color: #8cb4e8; display: flex;}
            `}} />

            <div className="fm-app-main">
                <AnimatedPage>
                    
                    {/* ===== HEADER ===== */}
                    <div className="fm-header">
                        <div className="fm-header-back" onClick={handleBackClick}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#333"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
                        </div>
                        <div className="fm-header-title">Quản lý quỹ</div>
                        <div style={{ width: '24px' }}></div> 
                    </div>

                    {/* ===== VÍ CỦA TÔI ===== */}
                    <div className="fm-wallet-sec">
                        <div className="fm-wallet-title">
                            <div className="fm-wallet-icon">
                                {/* Icon Ví màu cam */}
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="#f88c14"><path d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0 0 22 15V9a2 2 0 0 0-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"/><circle cx="16" cy="12" r="1.5"/></svg>
                            </div>
                            Ví của tôi
                            <div className={`fm-refresh-icon ${isRefreshing ? 'spinning' : ''}`} onClick={fetchBalance}>
                                {/* Icon Refresh màu xanh */}
                                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
                            </div>
                        </div>

                        <div className="fm-balance">
                            {profile?.money ? Number(profile.money).toLocaleString("vi-VN") : "0.00"}
                        </div>

                        {/* Nút Nạp / Rút */}
                        <div className="fm-action-btns">
                            <button className="fm-btn-fill" onClick={() => navigate("/recharge/bank")}>Nạp tiền</button>
                            <button className="fm-btn-outline" onClick={() => navigate("/withdraw")}>Rút tiền</button>
                        </div>

                        {/* Hình ảnh thẻ minh họa bên phải */}
                        <div className="fm-wallet-graphic">
                            <svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg">
                                {/* Bóng đổ */}
                                <rect x="15" y="25" width="80" height="50" rx="6" fill="rgba(248,140,20,0.15)" transform="rotate(-5 50 50)" />
                                {/* Thẻ chính */}
                                <rect x="10" y="20" width="80" height="50" rx="6" fill="#f8a145" transform="rotate(-10 50 50)" />
                                <rect x="10" y="20" width="80" height="50" rx="6" fill="url(#grad)" transform="rotate(-10 50 50)" />
                                {/* Chip / Vạch trắng */}
                                <rect x="20" y="28" width="15" height="4" rx="2" fill="#fff" transform="rotate(-10 50 50)" opacity="0.9"/>
                                <defs>
                                    <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#f88c14" />
                                        <stop offset="100%" stopColor="#e67e22" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                    </div>

                    {/* ===== THẺ LỊCH SỬ ===== */}
                    <div className="fm-history-grid">
                        
                        {/* Lịch sử Nạp */}
                        <Link to="/transaction/history" className="fm-history-card">
                            <div className="fm-hc-left">
                                <div className="fm-hc-icon">
                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg>
                                </div>
                                <div className="fm-hc-text">Lịch sử nạp </div>
                            </div>
                            <div className="fm-hc-arrow">
                                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
                            </div>
                        </Link>

                        {/* Lịch sử Rút */}
                        <Link to="/transaction/history" className="fm-history-card">
                            <div className="fm-hc-left">
                                <div className="fm-hc-icon">
                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0 0 22 15V9a2 2 0 0 0-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"/></svg>
                                </div>
                                <div className="fm-hc-text">Lịch sử rút</div>
                            </div>
                            <div className="fm-hc-arrow">
                                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
                            </div>
                        </Link>

                    </div>

                </AnimatedPage>
            </div>
        </div>
    );
}

export default FundManager;